var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-eye_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.654 4c2.05 0 4.103 1.334 6.154 4-2.051 2.666-4.103 4-6.154 4S4.55 10.666 2.5 8c2.051-2.666 4.103-4 6.154-4Zm0 .615c-1.736 0-3.528 1.109-5.37 3.385 1.842 2.276 3.634 3.385 5.37 3.385 1.682 0 3.42-1.042 5.203-3.181L14.024 8l-.167-.204c-1.784-2.139-3.52-3.18-5.203-3.18Zm0 1.231a2.154 2.154 0 1 1 0 4.308 2.154 2.154 0 0 1 0-4.308Zm0 .616a1.538 1.538 0 1 0 0 3.077 1.538 1.538 0 0 0 0-3.077Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-eye_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.5 4)",
    d: "M0 0h12.308v8H0z"
  })))));
};
export default SvgIconEye;